import { FlowVas } from '../../interfaces/FlowVas/FlowVas'
import { flowVasActionTypes } from '../types/flowVasActionTypes'

export type FlowVasActions = FlowVasAction | FlowVasActionAsync

export interface FlowVasAction {
  type: typeof flowVasActionTypes.GET_FLOW_VAS_EXITO
  flowVas: FlowVas[] | undefined
  error: string | undefined
}

export const getFlowVasAction = (
  flowVas?: FlowVas[],
  error?: string
): FlowVasAction => {
  return {
    type: flowVasActionTypes.GET_FLOW_VAS_EXITO,
    flowVas,
    error
  }
}

// Esto va a SAGA
export interface FlowVasActionAsync {
  type: typeof flowVasActionTypes.GET_FLOW_VAS
}

export const getFlowVasActionAsync = (): FlowVasActionAsync => {
  return {
    type: flowVasActionTypes.GET_FLOW_VAS
  }
}
